import MainModule from './main'
import MonitorizationModule from './monitorization'
import ProductionControlModule from './production_control'
import OrderReferenceView from './order_reference_view'


export default {
    ...MainModule,
    modules: {
        'monitorization': MonitorizationModule,
        'production_control': ProductionControlModule,
        'order_reference_view': OrderReferenceView
    }
}
